import { Box } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import type { ScreenerEvent } from '../api/boardTypes';
import { eventHref } from '../board/routes';
import { NEW_TAB_LINK_PROPS } from '../../../../utils/newTab';

export const EVENT_OPEN_LINK_TEST_ID = 'card-event-open-link';

export interface EventOpenLinkProps {
    event: Pick<ScreenerEvent, 'event_id' | 'slug'>;
    onOpenEvent?: (e: React.MouseEvent) => void;
    size?: number;
}

export function EventOpenLink({
    event,
    onOpenEvent,
    size = 13,
}: EventOpenLinkProps) {
    return (
        <Box
            component="a"
            href={eventHref(event.event_id, event.slug)}
            {...NEW_TAB_LINK_PROPS}
            data-testid={EVENT_OPEN_LINK_TEST_ID}
            aria-label="Open event page"
            title="Open event"
            onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                onOpenEvent?.(e);
            }}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                p: '2px',
                borderRadius: '3px',
                color: 'text.secondary',
                textDecoration: 'none',
                '&:hover': { color: 'primary.main', bgcolor: 'action.hover' },
                '&:focus-visible': {
                    outline: '1px solid',
                    outlineColor: 'primary.main',
                },
            }}
        >
            <OpenInNewIcon sx={{ fontSize: size }} />
        </Box>
    );
}
